/* eslint-disable react/prop-types */
import React from 'react';
import Stepper from 'components/layout/Stepper';
import { Link } from 'react-router-dom';
import { LogoContent, Header, SideBannerContainer } from './styles';

const SideBanner = ({ activated, header, steppers }) => {
  return (
    <SideBannerContainer>
      <LogoContent>
        <Link to="/">
          <img
            width={173.42}
            src="/static/ultragaz-logo-white.svg"
            alt="Logo da Ultragaz"
          />
        </Link>
      </LogoContent>
      <Header>
        <h1>{header.h1}</h1>
        <h2 dangerouslySetInnerHTML={{ __html: header.h2 }} />
      </Header>
      <Stepper activated={activated} steppers={steppers} />
    </SideBannerContainer>
  );
};

export default SideBanner;
